import './navbar.js'
import './ganalytics.js'
import '../stylesheets/_custom.scss'
import '../stylesheets/general.styl'
import '../stylesheets/navbar.styl'
import '../stylesheets/footer.styl'
import '../stylesheets/downloads.styl'

import 'bootstrap/dist/js/bootstrap.bundle.min';


class DropdownManager {
  constructor(parent, target) {
    this.parent = document.querySelector(parent);
    this.target = document.querySelector(target);

    this.parent.addEventListener('click', this.toggleVisibility.bind(this));
    document.addEventListener('click', this.handleDocumentClick.bind(this));
  }

  toggleVisibility() {
    this.target.classList.toggle('d-none');
  }

  handleDocumentClick(event) {
    if (!this.parent.contains(event.target) && !this.target.classList.contains('d-none')) {
      this.target.classList.add('d-none');
    }
  }
}

const fetchCommitHistory = async () => {
  try {
    const response = await fetch('/api/update/nightly/history');
    const data = await response.json();
    if (data.length > 0) {
      document.querySelector("#commit-history").style.display = "block";
      const commitList = document.querySelector("#commit-list");
      data.forEach(commit => {
        const li = document.createElement('li');
        li.textContent = `[${commit.date}] (${commit.hash}) ${commit.message}`;
        commitList.append(li);
      });
    }
  } catch (error) {
    console.error(error);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  new DropdownManager("#linux-arch-selector", "#linux-arch-dropdown");
  new DropdownManager("#linux-nightly-arch-selector", "#linux-nightly-arch-dropdown");
  fetchCommitHistory();
});
